import { Box, Modal } from '@mui/material'
import type { FC } from 'react'

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
}

type Props = {
  open: boolean
  onClose: () => void
}

const Prompt: FC<Props> = ({ children, open, onClose }) => (
  <Modal open={open} onClose={onClose}>
    <Box sx={style}> {children}</Box>
  </Modal>
)

export default Prompt
